export default __webpack_public_path__ + "static/media/team-call.68915fdb.mp3";